import React from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
const QuickGlancetrdslide = () => {
  const options = {
    nav: false,
    items:1,
    autoplay: true,
    smartSpeed: 1000,
     };
  return (
    <>
      <OwlCarousel className="owl-carousel" {...options}>
        <div className="item">
        <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/achievement.jpg" className="image" alt="Lotus Valley International School, Greater Noida"/>
        </div>
        <div className="item">
        <div className="draw-border">
        <h3><Link to="OurAchievements">Achievement</Link></h3>
        <p>Achievements are things you did that had a lasting impact for your School. It is a result that you personally bring about while fulfilling a particular role. Typically they are things that you created, built, designed.</p>
        
      </div>
        </div>
      </OwlCarousel>
    </>
  );
};

export default QuickGlancetrdslide;
